import type { ReactNode } from 'react';

/**
 * Linha ícone + título + subtítulo dos recibos — hóspede/viajante, centro de
 * custo, motivo. Usada pelo `flight_reservation`.
 *
 * `data-receipt-row` é seam de TESTE, não gancho de estilo: os testes precisam
 * escopar "este subtítulo pertence a esta pessoa", e fazer isso por classe
 * utilitária quebra a cada ajuste de espaçamento. Mesmo espírito do
 * `data-money-role`.
 */
export function ReceiptRow({
  icon,
  title,
  sub,
}: {
  readonly icon: ReactNode;
  readonly title: string;
  readonly sub: string;
}) {
  return (
    <div className="flex items-center gap-3.5" data-receipt-row="">
      <span className="inline-flex shrink-0 text-muted-foreground">{icon}</span>
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="text-ui truncate text-foreground">{title}</span>
        <span className="text-detail text-muted-foreground">{sub}</span>
      </div>
    </div>
  );
}

/** Uma linha do breakdown de valores: rótulo à esquerda, valor à direita. */
export function ValueRow({ label, value }: { readonly label: string; readonly value: string }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <span className="text-ui font-normal text-muted-foreground">{label}</span>
      <span className="text-ui font-normal text-foreground">{value}</span>
    </div>
  );
}
